<template>
  <div class="filterbtn" :class="classes" @mousedown="doRipple($event)">
	  <slot></slot>
    <div class="ripple" :style="rippleStyle()"></div>
  </div>
</template>


<script>
export default {
  props: ['active'],
  data(){
    return {
      ripple: {
          top: 0,
          left: 0,
          size: 150,
          active: false,
      }
    }
  },
  computed:{
    classes(){
      var output = ''
      if( this.active ) output += ' active '
      if( this.ripple.active ) output += ' rippling '
      return output
    },
  },
  methods: {

    doRipple(e){
      if( this.ripple.active ) return
      this.ripple.top = e.offsetY
      this.ripple.left = e.offsetX
      this.ripple.active = true
      var _this = this
      setTimeout(function(){
        _this.ripple.active = false
      }, 400)
    },

    rippleStyle() {
        return {
            height: this.ripple.size + 'px',
            width: this.ripple.size + 'px',
            top: this.ripple.top + 'px',
            left: this.ripple.left + 'px',
            marginLeft: - (this.ripple.size/2) + 'px',
            marginTop: - (this.ripple.size/2) + 'px',
        };
    },

  },
}
</script>



// WEBPACK FOOTER //
// Filterbtn.vue?08fc271e